import { useState } from "react";
import { useSearchNflPlayersQuery } from "../store/api/nflApi";
import { formatPlayerName } from "../utils/textUtils";

export const useNflPlayerSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const searchQuery = useSearchNflPlayersQuery(
    searchTerm.length >= 2 ? searchTerm : null,
    {
      skip: searchTerm.length < 2,
    }
  );

  const handleSearchInputChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
  };

  const getPlayerOptionLabel = (option) => {
    if (!option) return "";
    return formatPlayerName(option);
  };

  const isPlayerOptionEqualToValue = (option, value) => {
    if (!option || !value) return false;
    return option.playerId === value.playerId;
  };

  const renderPlayerOption = (props, option) => {
    const displayName = formatPlayerName(option);
    const yards =
      option.popularityScore ??
      option.stats?.passing?.career?.yds ??
      "0";
    const position = option.bio?.position || option.bioData?.position;

    const { key, ...otherProps } = props;

    return (
      <li key={option.playerId || key} {...otherProps}>
        <div>
          <div style={{ fontWeight: "bold" }}>{displayName}</div>
          <div style={{ fontSize: "0.875rem", color: "#666" }}>
            {position ? `${position} · ` : ""}Pass Yds: {yards}
          </div>
        </div>
      </li>
    );
  };

  return {
    searchTerm,
    searchQuery,
    handleSearchInputChange,
    getPlayerOptionLabel,
    isPlayerOptionEqualToValue,
    renderPlayerOption,
  };
};
